import BookIcon from "../../assets/images/ic_excel.svg";
import Pagination from "../../sharedComponent/Pagination";
import React, { useContext, useEffect, useState } from "react";
import down_arrow from "../../assets/images/down_arrow.svg";
import ic_search_dark from "../../assets/images/ic_search_dark.svg";
import searchicon from "../../assets/images/ic_search.svg";
import { Form, Tab, Tabs } from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { simpleGetCallWithToken } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";

function AgentCallSummary() {
  const { sidebar, setSidebar, Dark, setDark, userData, permissions, setIsCAllHistory, isCallHistory } =
    useContext(AppContext);

  const [key, setKey] = useState("all");
  console.log("Key data >>>>>>>>>>", key);

  // show button
  const [selectedRows, setSelectedRows] = useState(10);
  const [agentList, SetAgentList] = useState([])
  const [loading, setLoading] = useState(false)
  let naviget = useNavigate()

  const handleSelectChange = (event) => {
    setSelectedRows(event.target.value);
    console.log(`Selected number of rows: ${event.target.value}`);
    // You can add additional logic to handle the row change
  };
  // show button end

  

  const handleCallHistory = (item) => {
    console.log("Call History", item.agent_id);
    naviget("/AgentCallSummaryDetails/" + item.agent_id)
    setIsCAllHistory(false);

  }

  const handleCallHistorys = (item) => {
    console.log("Call History", item.agent_id);
    naviget("/AgentCallSummaryDetails/" + item.agent_id)
    setIsCAllHistory(true);
  }
  const getcrmCallData = () => {
    // setLoading(true)
    simpleGetCallWithToken(ApiConfig.AGENT_CALL_REPORTS)
      .then((res) => {
        console.log("Call List Data>>>", res)
        SetAgentList(res)
      })
      .catch((err) => {
        // setLoading(false)

        console.log("call List Data>>>", err)
      })
  }

  useEffect(() => {
    getcrmCallData()
  }, [])

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="role-content">
        <div className="sub-header-role">
          <h6 className="mt-2">Agent Call Summary</h6>
          <Link to={"/AgentcallList"}>
            <button className="custoBtnForCrmCall">
              {/* <a className=" textcolor" href=""> */}
              Add Agent Priority
              {/* </a> */}
            </button>
          </Link>

        </div>

        {/* <div className="d-flex justify-content-between mainHeader custom-mb mt-4">
          <div className="role-table-header-main">
            <div className="search-input-wrapper mt-0 cus-mb">
              <input type="text" placeholder="Search here" />

              {Dark === "lightMode" ? (
                <img src={searchicon} alt="" />
              ) : (
                <img src={ic_search_dark} alt="" />
              )}
            </div>
            <div className="entries-wrapper mt-0 cus-mb">
              <p>Entries per page</p>
              <select
                className="form-select select-drop-icon"
                aria-label="Default select example"
                value={selectedRows}
                onChange={handleSelectChange}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>
          <div className="d-flex justify-content-between mainIcons">
            {
              permissions && permissions['View Agent Call Summary Export'] &&

              <div className="booksIcon" style={{ textAlign: "center" }}>
                <img src={BookIcon} className="innerIconsBtn" alt="" />
              </div>
            }
          </div>
        </div> */}

        <Form noValidate id="crm-call-form">
          <div id="tabsBelow" className="mt-4">
            <Tabs
              defaultActiveKey="profile"
              id="uncontrolled-tab-example"
              // className="mb-0"
              activeKey={key}
              onSelect={(k) => setKey(k)}
            >
              <Tab eventKey="all" title="All">
                <div className="table-wrapper" id="scrol-tblNtable-wrapper-af">
                  <table>
                    <thead>
                      <tr className="firstTabelRow">
                        <th scope="col">Mobile Number</th>
                        <th scope="col">Call Time</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {crmCallData.map((data, index) => (
                        <tr key={index} className="table-row-custom">
                          <td>{data.mobileNumber}</td>
                          <td>{data.callTime}</td>
                          <td>{data.status}</td>
                        </tr>
                      ))} */}
                    </tbody>
                  </table>
                  {/* <Pagination /> */}
                </div>
              </Tab>
              <Tab eventKey="inboundCalls" title="Agent Week Call Summary">
                <div className="table-wrapper" id="scrol-tblNtable-wrapper-af">
                  <table>
                    <thead>
                      <tr className="firstTabelRow">
                        <th scope="col">AGENT NAME</th>
                        <th scope="col">COUNTS</th>
                        <th scope="col">CALL DETAILS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              <Loader />
                            </td>
                          </tr>
                        ) : (
                          agentList?.weekly?.map((data, index) => (
                            <tr key={index} className="table-row-custom">
                              <td>{data.agent_name}</td>
                              <td>{data?.weekly_count}</td>
                              <td>
                                <button className="custoBtnForCrmCall"
                                  onClick={() =>
                                    handleCallHistory(data)
                                  }>
                                  <Link
                                    className="details-link"
                                  >
                                    call history
                                  </Link>
                                </button>


                              </td>
                            </tr>
                          ))
                        )}
                    </tbody>
                  </table>
                  {/* <Pagination /> */}
                </div>
              </Tab>
              <Tab eventKey="outboundCalls" title="Agent Daily Call Summary">
                <Tab.Content>
                  <div
                    className="table-wrapper"
                    id="scrol-tblNtable-wrapper-af"
                  >
                    <table>
                      <thead>
                        <tr className="firstTabelRow">
                          <th scope="col">AGENT NAME</th>
                          <th scope="col">COUNTS</th>
                          <th scope="col">CALL DETAILS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          loading ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                <Loader />
                              </td>
                            </tr>
                          ) : (
                            agentList?.daily?.map((data, index) => (
                              <tr key={index} className="table-row-custom">
                                <td>{data.agent_name}</td>
                                <td>{data?.daily_count}</td>
                                <td>
                                  <button className="custoBtnForCrmCall" onClick={() => 

                                    
                                      handleCallHistorys(data)
                                      
                                   
                                  }
                                  >
                                    <Link
                                      className="details-link"
                                    >
                                      call history
                                    </Link>
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                      </tbody>
                    </table>
                    {/* <Pagination /> */}
                  </div>
                </Tab.Content>
              </Tab>
            </Tabs>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default AgentCallSummary;
